import { isEmpty } from 'lodash';
import { Dispatch } from 'redux';
import { apiErrorClear } from '../../../../../global/ducks/base-api';
import { patchCompensationWithHandler, postCalculateTotals, postCompensationWithHandler } from '../../../../../global/ducks/benadmin-api';
import { formatDate, parseChanged } from '../../../../../global/helpers/form-data-helper';
import { ApiStatuses } from '../../../../../global/models/api-model';
import { CalculatedTotals, CompensationResponseData, ScheduledPayment } from '../compensation-history/compensation-history-model';
import { addScheduledPayment, setCalculatedTotals, setUpdateCompensationStatus } from '../compensation-history/compensation-history-slice';
import { ScheduledPaymentFormValues } from './scheduled-payment-form-model';

export const calculateTotals = (
	dispatch: Dispatch<any>,
	employeeId: string | number,
	formValues: ScheduledPaymentFormValues,
	employmentId: number) => {

    const payload = {
        compensation: {
            ...formValues,
            effective_date: formatDate(formValues.effective_date),
            housing_provided: formValues.housing_provided ? formValues.housing_provided.toLowerCase() : null,
        },
        employee_id: employeeId,
        employment_id: employmentId,
    };

    dispatch(postCalculateTotals(employeeId, employmentId, payload, (response) => {
        const calculatedTotals: CalculatedTotals = {
            calculated_housing: response.data.calculated_housing,
            calculated_housing_dc_rsvp: response.data.calculated_housing_dc_rsvp,
            tac: response.data.tac,
            tac_dc_rsvp: response.data.tac_dc_rsvp,
        };

        dispatch(setCalculatedTotals(calculatedTotals));
    }));
};

export const postScheduledPayment = (
	dispatch: Dispatch<any>,
	employeeId: string | number,
	savedValues: ScheduledPaymentFormValues,
	formValues: ScheduledPaymentFormValues,
    employmentId: number) => {

	const changed = parseChanged(savedValues, formValues);
	if (isEmpty(changed)) {
		return;
    }

    dispatch(apiErrorClear());

	const payload = {
		compensation: {
			...formValues,
			effective_date: formatDate(formValues.effective_date),
			housing_provided: formValues.housing_provided ? formValues.housing_provided.toLowerCase() : null,
		},
        employee_id: employeeId,
        employment_id: employmentId,
	};


	const postSuccess = (responseData: CompensationResponseData) => {
        dispatch(addScheduledPayment(responseData));
        dispatch(setUpdateCompensationStatus(ApiStatuses.Success));
	};

    dispatch(postCompensationWithHandler(employeeId, employmentId, payload, (postResponse) => postSuccess(postResponse.data)));
};


export const patchScheduledPayments = (
	dispatch: Dispatch<any>,
	employeeId: string | number,
	savedValues: ScheduledPaymentFormValues,
	formValues: ScheduledPaymentFormValues,
	currentScheduledPayment: ScheduledPayment) => {

	const changed = parseChanged(savedValues, formValues);
	if (isEmpty(changed)) {
		return;
	}

    dispatch(apiErrorClear());

	const payload = {
		compensation: {
			...changed,
			housing_provided: formValues.housing_provided ? formValues.housing_provided.toLowerCase() : null,
		},
        employee_id: employeeId,
		employment_id: currentScheduledPayment.employment_id,
		id: currentScheduledPayment.id,
	};


	const postSuccess = (responseData: CompensationResponseData) => {
        dispatch(addScheduledPayment(responseData));
        dispatch(setUpdateCompensationStatus(ApiStatuses.Success));
	};

    dispatch(patchCompensationWithHandler(employeeId, currentScheduledPayment.employment_id, currentScheduledPayment.id, payload, (patchResponse) => postSuccess(patchResponse.data)));
};